import { render, staticRenderFns } from "./CorrectAnswerForm.vue?vue&type=template&id=f46228cc&scoped=true&"
import script from "./CorrectAnswerForm.vue?vue&type=script&lang=js&"
export * from "./CorrectAnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./CorrectAnswerForm.vue?vue&type=style&index=0&id=f46228cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46228cc",
  null
  
)

export default component.exports